import { getResmgrRoleConfig } from 'openstack/components/infrastructure/actions'
import { flatten, uniq } from 'ramda'

export const getValidVolumeTypes = async ({
  hosts,
  setActiveVolumeBackends,
  setLoadingVolumeBackends,
}) => {
  // Filter out hosts that are not responding or do not have the persistent-storage role
  const onlineStorageHosts = hosts.filter(
    (host) => host?.info?.responding && host?.roles?.includes('persistent-storage'),
  )
  const results = await Promise.allSettled(
    onlineStorageHosts.map((host) =>
      getResmgrRoleConfig({ role: 'pf9-cindervolume-config', host: host }),
    ),
  )
  const volumeBackends = results.map((result: any) => {
    if (result?.value?.backends) {
      const values = Object.values(result.value.backends)
      return uniq(values.map((value: any) => value.volume_backend_name))
    }
    return []
  })
  const uniqueVolumeBackends = uniq(flatten(volumeBackends))
  setActiveVolumeBackends(uniqueVolumeBackends)
  setLoadingVolumeBackends(false)
}
